<template>
  <v-chip v-bind="$attrs" v-on="$listeners">
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </v-chip>
</template>

<script>
export default {
  name: "AChip",
};
</script>

<style scoped>
.v-chip {
  justify-content: center !important;
  align-items: center !important;
  border: 2px solid;
}
::v-deep .v-chip__content {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
}
.opened {
  font-weight: 700 !important;
}
.minute {
  background: var(--v-Neutral-base) !important;
  border-color: #cccccc !important;
}
.high {
  background-color: #ffebeb !important;
  border-color: var(--v-accent-base) !important;
  color: var(--v-accent-base);
  /* width: 80px; */
}
.medium {
  background: #fff7e6 !important;
  border-color: #e69900 !important;
  /* width: 80px; */
}
.low {
  background: var(--v-Neutral-base) !important;
  border-color: #cccccc !important;
  /* width: 80px; */
}
</style>